export const Localize = {
    "en_US": {
        "pwa_install_title": "Install {appName}",
        "pwa_install_chromium_subtitle": "Get faster access from your home screen.",
        "pwa_install_ios_subtitle": "Tap the \"...\" menu > Share > View More > \"Add to Home Screen\".",
        "pwa_install_mac_safari_subtitle": "From the File menu, choose \"Add to Dock\".",
        "pwa_install_install_btn": "Install",
        "pwa_install_not_now_btn": "Dismiss",
        "pwa_install_got_it_btn": "Got it",
        "install_application": "Install application"
    },
    "en_GB": {
        "pwa_install_title": "Install {appName}",
        "pwa_install_chromium_subtitle": "Get faster access from your home screen.",
        "pwa_install_ios_subtitle": "Tap the \"...\" menu > Share > View More > \"Add to Home Screen\".",
        "pwa_install_mac_safari_subtitle": "From the File menu, choose \"Add to Dock\".",
        "pwa_install_install_btn": "Install",
        "pwa_install_not_now_btn": "Dismiss",
        "pwa_install_got_it_btn": "Got it",
        "install_application": "Install application"
    },
    "en_AU": {
        "pwa_install_title": "Install {appName}",
        "pwa_install_chromium_subtitle": "Get faster access from your home screen.",
        "pwa_install_ios_subtitle": "Tap the \"...\" menu > Share > View More > \"Add to Home Screen\".",
        "pwa_install_mac_safari_subtitle": "From the File menu, choose \"Add to Dock\".",
        "pwa_install_install_btn": "Install",
        "pwa_install_not_now_btn": "Dismiss",
        "pwa_install_got_it_btn": "Got it",
        "install_application": "Install application"
    },
    "en_CA": {
        "pwa_install_title": "Install {appName}",
        "pwa_install_chromium_subtitle": "Get faster access from your home screen.",
        "pwa_install_ios_subtitle": "Tap the \"...\" menu > Share > View More > \"Add to Home Screen\".",
        "pwa_install_mac_safari_subtitle": "From the File menu, choose \"Add to Dock\".",
        "pwa_install_install_btn": "Install",
        "pwa_install_not_now_btn": "Dismiss",
        "pwa_install_got_it_btn": "Got it",
        "install_application": "Install application"
    },
    "de_DE": {
        "pwa_install_title": "{appName} installieren",
        "pwa_install_chromium_subtitle": "Schneller Zugriff über den Startbildschirm.",
        "pwa_install_ios_subtitle": "Tippen Sie auf das Menü „…\" > Teilen > Mehr anzeigen > „Zum Home-Bildschirm\".",
        "pwa_install_mac_safari_subtitle": "Wählen Sie im Menü „Ablage\" die Option „Zum Dock hinzufügen\".",
        "pwa_install_install_btn": "Installieren",
        "pwa_install_not_now_btn": "Schließen",
        "pwa_install_got_it_btn": "Verstanden",
        "install_application": "Anwendung installieren"
    },
    "es_ES": {
        "pwa_install_title": "Instalar {appName}",
        "pwa_install_chromium_subtitle": "Acceda más rápido desde su pantalla de inicio.",
        "pwa_install_ios_subtitle": "Toque el menú \"…\" > Compartir > Ver más > \"Añadir a pantalla de inicio\".",
        "pwa_install_mac_safari_subtitle": "En el menú Archivo, elija \"Añadir al Dock\".",
        "pwa_install_install_btn": "Instalar",
        "pwa_install_not_now_btn": "Descartar",
        "pwa_install_got_it_btn": "Entendido",
        "install_application": "Instalar aplicación"
    },
    "es_MX": {
        "pwa_install_title": "Instalar {appName}",
        "pwa_install_chromium_subtitle": "Acceso más rápido desde tu pantalla de inicio.",
        "pwa_install_ios_subtitle": "Toca el menú \"…\" > Compartir > Ver más > \"Agregar a pantalla de inicio\".",
        "pwa_install_mac_safari_subtitle": "En el menú Archivo, elige \"Agregar al Dock\".",
        "pwa_install_install_btn": "Instalar",
        "pwa_install_not_now_btn": "Descartar",
        "pwa_install_got_it_btn": "Entendido",
        "install_application": "Instalar aplicación"
    },
    "es_AR": {
        "pwa_install_title": "Instalar {appName}",
        "pwa_install_chromium_subtitle": "Acceso más rápido desde tu pantalla de inicio.",
        "pwa_install_ios_subtitle": "Tocá el menú \"…\" > Compartir > Ver más > \"Agregar a pantalla de inicio\".",
        "pwa_install_mac_safari_subtitle": "En el menú Archivo, elegí \"Agregar al Dock\".",
        "pwa_install_install_btn": "Instalar",
        "pwa_install_not_now_btn": "Descartar",
        "pwa_install_got_it_btn": "Entendido",
        "install_application": "Instalar aplicación"
    },
    "fr_FR": {
        "pwa_install_title": "Installer {appName}",
        "pwa_install_chromium_subtitle": "Accédez plus rapidement depuis votre écran d'accueil.",
        "pwa_install_ios_subtitle": "Touchez le menu « … » > Partager > Afficher plus > « Sur l'écran d'accueil ».",
        "pwa_install_mac_safari_subtitle": "Dans le menu Fichier, choisissez « Ajouter au Dock ».",
        "pwa_install_install_btn": "Installer",
        "pwa_install_not_now_btn": "Ignorer",
        "pwa_install_got_it_btn": "Compris",
        "install_application": "Installer l'application"
    },
    "fr_CA": {
        "pwa_install_title": "Installer {appName}",
        "pwa_install_chromium_subtitle": "Accédez plus rapidement depuis votre écran d'accueil.",
        "pwa_install_ios_subtitle": "Touchez le menu « … » > Partager > Afficher plus > « Sur l'écran d'accueil ».",
        "pwa_install_mac_safari_subtitle": "Dans le menu Fichier, choisissez « Ajouter au Dock ».",
        "pwa_install_install_btn": "Installer",
        "pwa_install_not_now_btn": "Ignorer",
        "pwa_install_got_it_btn": "Compris",
        "install_application": "Installer l'application"
    },
    "it_IT": {
        "pwa_install_title": "Installa {appName}",
        "pwa_install_chromium_subtitle": "Accedi più velocemente dalla schermata Home.",
        "pwa_install_ios_subtitle": "Tocca il menu \"…\" > Condividi > Mostra altro > \"Aggiungi a Home\".",
        "pwa_install_mac_safari_subtitle": "Dal menu File, scegli \"Aggiungi al Dock\".",
        "pwa_install_install_btn": "Installa",
        "pwa_install_not_now_btn": "Ignora",
        "pwa_install_got_it_btn": "OK",
        "install_application": "Installa applicazione"
    },
    "ja_JP": {
        "pwa_install_title": "{appName}をインストール",
        "pwa_install_chromium_subtitle": "ホーム画面からすばやくアクセスできます。",
        "pwa_install_ios_subtitle": "「…」メニューをタップ ＞ 共有 ＞ その他を表示 ＞ 「ホーム画面に追加」",
        "pwa_install_mac_safari_subtitle": "ファイルメニューから「Dockに追加」を選択してください。",
        "pwa_install_install_btn": "インストール",
        "pwa_install_not_now_btn": "閉じる",
        "pwa_install_got_it_btn": "OK",
        "install_application": "アプリケーションをインストール"
    },
    "ko_KR": {
        "pwa_install_title": "{appName} 설치",
        "pwa_install_chromium_subtitle": "홈 화면에서 빠르게 접근하세요.",
        "pwa_install_ios_subtitle": "\"…\" 메뉴 탭 > 공유 > 더 보기 > \"홈 화면에 추가\".",
        "pwa_install_mac_safari_subtitle": "파일 메뉴에서 \"Dock에 추가\"를 선택하세요.",
        "pwa_install_install_btn": "설치",
        "pwa_install_not_now_btn": "닫기",
        "pwa_install_got_it_btn": "확인",
        "install_application": "애플리케이션 설치"
    },
    "pl_PL": {
        "pwa_install_title": "Zainstaluj {appName}",
        "pwa_install_chromium_subtitle": "Szybszy dostęp z ekranu głównego.",
        "pwa_install_ios_subtitle": "Dotknij menu \"…\" > Udostępnij > Pokaż więcej > \"Do ekranu początkowego\".",
        "pwa_install_mac_safari_subtitle": "W menu Plik wybierz \"Dodaj do Docka\".",
        "pwa_install_install_btn": "Zainstaluj",
        "pwa_install_not_now_btn": "Odrzuć",
        "pwa_install_got_it_btn": "Rozumiem",
        "install_application": "Zainstaluj aplikację"
    },
    "pt_BR": {
        "pwa_install_title": "Instalar {appName}",
        "pwa_install_chromium_subtitle": "Acesso mais rápido a partir da tela inicial.",
        "pwa_install_ios_subtitle": "Toque no menu \"…\" > Compartilhar > Ver mais > \"Adicionar à Tela de Início\".",
        "pwa_install_mac_safari_subtitle": "No menu Arquivo, escolha \"Adicionar ao Dock\".",
        "pwa_install_install_btn": "Instalar",
        "pwa_install_not_now_btn": "Dispensar",
        "pwa_install_got_it_btn": "Entendi",
        "install_application": "Instalar aplicativo"
    },
    "pt_PT": {
        "pwa_install_title": "Instalar {appName}",
        "pwa_install_chromium_subtitle": "Acesso mais rápido a partir do ecrã principal.",
        "pwa_install_ios_subtitle": "Toque no menu \"…\" > Partilhar > Ver mais > \"Adicionar ao Ecrã Principal\".",
        "pwa_install_mac_safari_subtitle": "No menu Ficheiro, escolha \"Adicionar à Dock\".",
        "pwa_install_install_btn": "Instalar",
        "pwa_install_not_now_btn": "Dispensar",
        "pwa_install_got_it_btn": "Entendi",
        "install_application": "Instalar aplicação"
    },
    "zh_CN": {
        "pwa_install_title": "安装 {appName}",
        "pwa_install_chromium_subtitle": "从主屏幕快速访问。",
        "pwa_install_ios_subtitle": "点击\"…\"菜单 > 分享 > 查看更多 > \"添加到主屏幕\"。",
        "pwa_install_mac_safari_subtitle": "在\"文件\"菜单中选择\"添加到程序坞\"。",
        "pwa_install_install_btn": "安装",
        "pwa_install_not_now_btn": "关闭",
        "pwa_install_got_it_btn": "知道了",
        "install_application": "安装应用"
    }
};
